<template>
  <div class="indexPc">
    <section class="index-top">
      <div class="top-content">
        <swiper
          class="swiper"
          ref="topSwiperPc"
          :options="topSwiperPcSwiperOptions"
        >
          <swiper-slide
            v-for="(item, index) in gData.top"
            :key="index"
            class="swiperItem"
          >
            <div class="info-content" :style="setBgUrl(innerWidth >= 900 ? item.img : item.ipadImg)"></div>
          </swiper-slide>
        </swiper>
        
        <div class="top-swiper-scrollbar-content">
          <div class="top-swiper-scrollbar"></div>
        </div>

        <div class="swiper-button-prev big"></div>
        <div class="swiper-button-next big"></div>
      </div>
    </section>

    <!-- 企业价值观 -->
    <section class="index-values-pc animated" ref="indexValues">
      <h2>企业价值观</h2>
      <h3>{{ shortName }}价值观来源于{{ shortName }}创始人创业及企业经营和管理的实践</h3>
      <div class="content">
        <swiper
          class="swiper"
          ref="valuesSwiperPc"
          :options="valuesSwiperOptions"
        >
          <swiper-slide
            v-for="(item, index) in gData.values"
            :key="index"
            class="swiperItem swiper-no-swiping"
          >
            <div class="info-content">
              <img :src="item.img" alt="item.title">
              <div class="mask"></div>
            </div>
          </swiper-slide>
        </swiper>

        <!-- 文案 -->
        <div class="text-content">
          <div class="text"
            v-for="(item, index) in gData.values"
            :key="index"
          >
            <p :class="['title', {active: index === valuesSwiperSelect}]" @mousedown="changeTitleEvt(index)">{{item.title}}</p>
            <p :class="['info', {active: index === valuesSwiperSelect}]" v-html="item.info" v-show="index === valuesSwiperSelect"></p>
          </div>
        </div>
        
        <!-- 滚动条 -->
        <div class="values-swiper-scrollbar-content">
          <div class="values-swiper-scrollbar"></div>
          <div class="prev" @mousedown="valuesSwiperPrev"></div>
          <div class="next" @mousedown="valuesSwiperNext"></div>
        </div>
      </div>

      <div class="lineCube1 big"></div>


      <img
          class="cube-div big cube-1 aniamtionCode"
          ref="cube_1"
          src="//img.ibestfanli.com/officialwebsite/img_block.png"
      />

      <img
        class="cube-div big cube-2 aniamtionCode"
        ref="cube_2"
        src="//img.ibestfanli.com/officialwebsite/img_block.png"
      />

    </section>

    <!-- 致力于构建移动应用生态 -->
    <section class="index-extenet-pc animated" ref="indexExtenet">
      <h2>致力于构建移动应用生态</h2>
      <h3>以标准化的产品和服务赋能，帮助开发者提升产品成功率</h3>
      <div class="content">
        <div class="point-ani-content" id="extenet-content-bg">
          <!-- <div class="point-1 pointAni1 point"></div>
          <div class="point-2 pointAni2 point"></div> -->
        </div>
        <div class="text-content">
          <div
            class="info-content"
            v-for="(item, index) in gData.extenets"
            :key="index"
          >
            <div class="num-content">
              <ICountUp
                class="num"
                :id="'num' + (index + 1)"
                :start="0"
                :endVal="endValArr[index]"
                :options="num1Options"
                :delay="1000"
                :speed="1"
              />
              <span class="unit" data-unit="+">{{
                item.isShowYiTxt ? "亿" : ""
              }}</span>
            </div>
            <div class="des">{{ item.txtXContent }}</div>
          </div>
        </div>
      </div>
      <img
        class="cube-div big cube-3 aniamtionCode"
        ref="cube_3"
        src="//img.ibestfanli.com/officialwebsite/img_block.png"
      />
    </section>

    <!-- 成熟的商业解决方案 -->
    <section class="index-pattern-pc animated" ref="indexPattern">
      <h2>成熟的商业解决方案</h2>
      <h3>“数字化建设”+“产品化运营”能力，驱动实现持续的创收增长</h3>
      <div class="content big">
        <div class="info-content">
          <div class="block-content"
            v-for="(item, index) in gData.patterns"
            :key="index"
            :class="{hover: index === activeHover}"
            @mouseenter="patternEnter(index)"
            @mouseleave="patternLeave(index)"
          >
            <div class="title">
              <div class="text">{{item.title}}</div>
              <div class="num">0{{index+1}}</div>
            </div>
            <div class="bottom">
              <div class="list"
                v-for="(item2, index2) in item.contents"
                :key="index2"
              >
                <div class="title-content">
                  <img :src="item2.icon" :alt="item2.stitle">
                  <p class="stitle">{{item2.title}}</p>
                </div>
                <div 
                  :class="['des', {noWrap: hoverAnimation}]"
                >{{item2.content}}</div>
              </div>
            </div>

            <img class="bg-icon" :src="item.image" alt="">
          </div>
        </div>
      </div>

      <!-- ipad -->
      <div class="content small">
        <div class="slide-content">
          <swiper
            class="swiper"
            ref="slideSwiper"
            :options="slideSwiperOpts"
          >
            <swiper-slide
              v-for="(item, index) in gData.patterns"
              :key="index"
            >
              <div class="block-content">
                <div class="title">
                  <div class="text">{{item.title}}</div>
                  <div class="num">0{{index+1}}</div>
                </div>
                <div class="bottom">
                  <div class="list"
                    v-for="(item2, index2) in item.contents"
                    :key="index2"
                  >
                    <div class="title-content">
                      <img :src="item2.icon" :alt="item2.stitle">
                      <p class="stitle">{{item2.title}}</p>
                    </div>
                    <div class="des">{{item2.content}}</div>
                  </div>
                </div>
            </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="pattern-swiper-scrollbar swiper-scrollbar"></div>
      </div>


      <img
        class="cube-div big cube-4 aniamtionCode"
        ref="cube_4"
        src="//img.ibestfanli.com/officialwebsite/img_block.png"
      />
    </section>

    <!-- 加入xm -->
    <section  class="index-join-pc animated" ref="joinMmPc">
      <h2>加入{{ shortName }}</h2>
      <h3>在这，一起探索你的未来</h3>
      <div class="lineCube2 big"></div>
      <div class="lineCube3 big"></div>

      <div class="content">
        <div class="join-btn" @mousedown="skipUrl">开启探索</div>
        <div class="littleCube littleCube1 aniamtionCode" ref="littleCube1"></div>
        <div class="littleCube littleCube2 aniamtionCode" ref="littleCube2"></div>
        <div class="littleCube littleCube3 aniamtionCode" ref="littleCube3"></div>
        <div class="littleCube littleCube4 aniamtionCode" ref="littleCube4"></div>
        <div class="littleCube littleCube5 aniamtionCode" ref="littleCube5"></div>
        <div class="littleCube littleCube6 aniamtionCode" ref="littleCube6"></div>
      </div>
    </section>

    <transition name="fade">
      <TopBtn v-show="showTopBtn"></TopBtn>
    </transition>
  </div>


</template>

<script>
import lottie from "lottie-web";
import ICountUp from "vue-countup-v2";
import TopBtn from '../../../components/topBtn/index';
import utils from "utils/utils";
import Config from '../../../utils/Config';
import CommonMethod from "utils/CommonMethod";
import websiteData from "data/websiteData";

export default {
  name: "indexPc",
  props: {
    gData: Object,
  },
  components: {
    ICountUp,
    TopBtn,
  },
  created() {
    this.commonMethod = new CommonMethod({
      context: this,
      navName: ''
    });
  },
  data() {
    return {
      skipHref: Config.domain,
      innerWidth: window.innerWidth,
      topSwiperPcSwiperOptions: {
        direction: "horizontal",
        effect : 'none',
        loop: true,
        autoplay: false,
        pagination: {
          el: '.top-swiper-scrollbar',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },

      //价值观
      valuesSwiperSelect: 0,
      valuesSwiperOptions: {
        direction: "vertical",
        effect : 'none',
        loop: true,
        autoplay: false,
        speed: 0,
        autoplayDisableOnInteraction: false,
        observer:true,
        pagination: {
          el: '.values-swiper-scrollbar',
        },
        on: {
          slideChange: () => {                  //控制幻灯片滑动的动画
            this.valuesSwiperSelect = this.valuesSwiperCtr.realIndex;
          },
        },
      },
      // 公司规模
      firstCount: true,
      num1Options: {
        useEasing: true,
        useGrouping: true,
      },
      newEndValArr: [110, 5, 20],
      endValArr: [0, 0, 0],

      // 成熟的商业解决方案
      activeHover: 0,

      // 是否在进行hover动画
      hoverAnimation: 0,

      // 全链路解决方案
      slideSwiperOpts: {
        direction: "horizontal",
        effect : 'coverflow',
        slidesPerView: 2,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 40,
          depth: 80,
          modifier: 2,
          slideShadows : false
        },
        loop: true,
        autoplay: false,
        scrollbar: {
          el: '.pattern-swiper-scrollbar',
        },
      },

      // 显示回到顶部按钮
      showTopBtn: 0,
      ...websiteData,
    };
  },
  computed: {
    valuesSwiperCtr() {
      // console.log(this.$refs.valuesSwiperPc.swiper);
      // this.$refs.valuesSwiperPc.swiper.updateSize();
      return this.$refs.valuesSwiperPc.swiper;
    },

    /* eslint-disable */
    setBgUrl(url) {
      return url => {
        let str = '';
        str = `background-image: url(${url})`;
        return str;
      }
    }


  },
  mounted() {
    this.commonMethod.init();
    window.addEventListener("scroll", this.scrollHandle, true);

    // 球在动
    lottie.loadAnimation({
      container: document.getElementById("extenet-content-bg"), // the dom element that will contain the animation
      renderer: "canvas",
      loop: true,
      autoplay: true,
      path: process.env.NODE_ENV !== 'production' ? './json/pointWithe.json' : this.skipHref + '/json/pointWithe.json', // the path to the animation json
    });
  },
  methods: {
    scrollHandle() {
      this.startCountNum();

      this.commonMethod.modelFadeInup("indexValues", 750, "weakFadeInUpLong");
      this.commonMethod.modelFadeInup("indexExtenet", 750, "weakFadeInUpLong");
      this.commonMethod.modelFadeInup("indexPattern", 750, "weakFadeInUpLong");
      this.commonMethod.modelFadeInup("joinMmPc", 750, "weakFadeInUpLong");


      this.commonMethod.cubeAnimation("cube_1",500,"once11","cubeMoveDown","cubeMoveDown2");
      this.commonMethod.cubeAnimation("cube_2",500,"once22","cubeMoveDown","cubeMoveDown2");
      this.commonMethod.cubeAnimation("cube_3",500,"once33","cubeMoveDown5","cubeMoveDown6");
      this.commonMethod.cubeAnimation("cube_4",500,"once44","cubeMoveDown5","cubeMoveDown6");

      this.showTopBtnEvt();

    },
    // 计数动画
    startCountNum() {
      const position = (window.innerHeight * 3) / 4;
      // console.log('position',position)
      const element = this.$refs.indexExtenet;

      if (utils.isEleSrollIntoViewPostion(element, position) && this.firstCount) {
        this.firstCount = false;
        this.endValArr = this.newEndValArr;
      }
    },
    valuesSwiperPrev() {
      this.valuesSwiperCtr.slidePrev();
    },
    valuesSwiperNext() {
      this.valuesSwiperCtr.slideNext();
    },
    changeTitleEvt(index) {
      this.valuesSwiperCtr.slideToLoop(index);
    },
    // 鼠标进入
    patternEnter(index) {
      // console.log(index);
      this.hoverAnimation = 1;
      this.activeHover = index;

      this.timer = setTimeout(() => this.hoverAnimation = 0, 500);
    },
    patternLeave() {
      // this.activeHover = -1;
      this.timer && clearTimeout(this.timer);
    },
    skipUrl() {
      window.location.href = Config.domain + '/about.html';
    },

    // 显示回到顶部按钮
    showTopBtnEvt() {
      const {top, height} = document.querySelector('.indexPc').getBoundingClientRect();
      // console.log(top, height);

      if (Math.abs(top) >= height / 2) {
        this.showTopBtn = 1;
      } else {
        this.showTopBtn = 0;
      }
    }
  },
};
</script>


<style lang="less" scoped>
section{
  position: relative;
  transform: translateY(80px);
  // background-color: #fff;
}
.big{
  display: block;
}
.small{
  display: none;
}

.content{
  padding-top: 60px;
  margin: 0 auto;
}


// 方法
.h2Pc{
  margin: 0;
  font-size: 36px;
  text-align: center;
  padding-top: 80px;
}
.h3Pc{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  padding-top: 12px;
  text-align: center;
}


.fz27{
  font-size: 27px;
}
.fz14{
  font-size: 14px;
}



/* -------- 样式 ----- */
h2{
  .h2Pc;
}
h3{
  .h3Pc;
}


.indexPc{
  width: 100%;
  // overflow-x: hidden;
}

.index-top{
  // .imgInfoP(100%, 670px, "index/top/img_banner_01.jpg");
  height: 670px;
  position: relative;
  overflow: hidden;
  .allCenter;
  transform: translateY(0);

  .top-content{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    cursor: pointer;

    &:hover{
      .swiper-button-prev,
      .swiper-button-next{
        opacity: 1;
      }
    }

    .swiper-container,
    .info-content {
      width: 100%;
      height: 100%;

      &.info-content{
        background-size: cover;
        background-position: center center;
      }
    }


    .swiper-button-prev,
    .swiper-button-next{
      .imgInfoP(56px, 56px, "index/top/icon_arrow.png");
      top: 307px;
      opacity: 0;
      outline: none;
      

      &.swiper-button-prev{
        left: 120px;
      }
      &.swiper-button-next{
        right: 120px;
        transform: rotateZ(180deg);
      }
    }
  }
}

.index-values-pc{
  transform: translateY(0);
  padding-bottom: 80px;

  .content{
    width: 1200px;
    position: relative;
  }

  h2,
  h3{
    width: 1200px;
    text-align: left;
    margin: 0 auto;
    font-size: 36px;
  }
  h3{
    color: #666;
    font-size: 18px;
  }
    
  .swiper-container{
    width: 480px;
    height: 480px;
    margin-left: 0;
    overflow: hidden;

    .swiper-wrapper,
    .swiper-slide,
    .info-content{
      overflow: hidden;
    }

    .info-content{
      position: relative;
    }
  }

  .mask{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, .5);
    transform: translate3d(0, -100%, 0);
  }

  .text-content{
    top: 18.5%;
    left: 120 + 480px;
    position: absolute;


    &::after{
      content: "";
      position: absolute;
      .imgInfoP(143px, 143px, "index/top/img_matrix_half.png");
      left: -190px;
      bottom: -120px;
    }

    .text{
      &:nth-of-type(1){
        .title{
          padding-top: 0;
        }
      }
    }

    .title{
      padding-top: 20px;
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #666666;
      cursor: pointer;

      &.active,
      &:hover{
        cursor: pointer;
        font-size: 28px;
        color: #222;
      }
    }

    .info{
      padding-top: 16px;
      width: 291px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 32px;
      margin-bottom: 40 - 20px;
      height: 96px;
      overflow: hidden;
    }
  }

  .swiper-slide-active{
    .mask{
      transform: translate3d(0, 100%, 0);
      transition: all 1s ease;
    }
  }

  .values-swiper-scrollbar-content{
    width: 4px;
    height: 300px;
    // background: #BBBBBB;
    // border-radius: 2px;
    position: absolute;
    right: 1200-1084px;
    top: 25.5%;
    border-radius: 50px;

    .values-swiper-scrollbar{
      width: 100%;
      height: 100%;
      position: relative;
      border-radius: inherit;
      overflow: hidden;

      .swiper-pagination-bullet{
        height: 100%;
      }
    }

    .prev,
    .next{
      cursor: pointer;
      width: 40px;
      height: 40px;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABxUlEQVR4Xu2XsUpDQRBFZ7DwE7TezY+IjWBjE3vBQlIIfonYiIWFtWlsBBvxRzJb6ydYyMiD9ySEJBqzszuwN02acN/cM/fuvjA1/uHG/RMAIAGNE0AFGg8ADkFUABVonAAq0HgAcAugAqhA4wRQgcYDgFsAFUAFGidQrQIxxgNVve74M/OViLzV2EUVADHGIyJ6UtXdHsAnEZ2IyEtpCMUBLJofDDNzFQhFAawyXxNCMQArzGtv/meO0kkoAmCN+UkP4LY7C2skwRzAOvMppbvOdAjhgoiqQDAF8Bfzw9ZrQTADsIn5mhBMAPzHfC0I2QFsY74GhKwAcpgvDSEbgBDCITM/D6+3vZHunp8Mp/2mr7mrDkZVPU4pvW6qt+z32QDEGEVVw9xDtjL/SxKSiERXAEII70S0l2Pzi8aWJOEjpbTvCsBoNDpV1ft+qEsRecgx4FwSzpj5pv/3eD6bzR5z6GerQDfMeDze6b6n0+lXjuEWNSz0swKwMG2tCQDWhL3rIwHeN2Q9HxJgTdi7PhLgfUPW8yEB1oS96yMB3jdkPR8SYE3Yuz4S4H1D1vMhAdaEvesjAd43ZD0fEmBN2Lt+8wn4Bifh0kEMF+XMAAAAAElFTkSuQmCC");
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      margin-left: -20px;

      &:hover{
        width: 32px;
        height: 32px;
        background-image: url("data:image/png;base64,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");
        transform: rotate(180deg);
        margin-left: -16px;

        &.prev{
          top: -35px;
        }
        &.next{
          bottom: -35px;
        }

      }
    }
    .prev{
      top: -40px;
    }
    .next{
      bottom: -40px;
      transform: rotateZ(180deg);

      &:hover{
        transform: rotate(0);
      }
    }
  }

  

  .cube-1{
    position: absolute;
    width: 473px;
    height: 473px;
    top: -160px;
    right: -180px;
  }

  .lineCube1{
    width: 141px;
    height: 141px;
    border-radius: 14px;
    border: 1px solid #3292ff;
    position: absolute;
    right: 0;
    top: 170px;
    transform: translateX(50%) rotate(45deg);
  }

  .cube-2{
    position: absolute;
    width: 220px;
    height: 220px;
    left: -100px;
    bottom: 20px;
  }

}

.index-extenet-pc{
  .content{
    padding-top: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    // .imgInfoP(100%, 370px, "index/extenet/bg_grid.png");
    position: relative;
    width: 100%;
    height: 370px;
    padding-bottom: 20px;
  }
  .point-ani-content{
    position: absolute;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;

    .point{
      width: 12px;
      height: 12px;
      background: #3292FF;
      border-radius: 6px;
      position: absolute;

      &.point-1{
        top: 58px;
        left: 423px;
      }
      &.point-2{
        bottom: 58px;
        right: 423px;
      }
    }
    

    // @keyframes pointAni1 {
    //   0%{
    //     transform: translate3d(0, 0, 0);
    //   }
    //   25%{
    //     transform: translate3d(690px, 0, 0);
    //   }
    //   50%{
    //     transform: translate3d(690px, 2000%, 0);
    //   }
    //   75%{
    //     transform: translate3d(0%, 2000%, 0);
    //   }
    //   100%{
    //     transform: translate3d(0, 0, 0);
    //   }
    // }
    // .pointAni1{
    //   animation: pointAni1 6s linear infinite;
    // }

    // @keyframes pointAni2 {
    //   0%{
    //     transform: translate3d(0, 0, 0);
    //   }
    //   25%{
    //     transform: translate3d(-690px, 0, 0);
    //   }
    //   50%{
    //     transform: translate3d(-690px, -2000%, 0);
    //   }
    //   75%{
    //     transform: translate3d(0%, -2000%, 0);
    //   }
    //   100%{
    //     transform: translate3d(0, 0, 0);
    //   }
    // }
    // .pointAni2{
    //   animation: pointAni2 6s linear infinite;
    // }



  }
  .text-content{
    width: 1200px;
    // margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .num-content{
      text-align: center;
      .num{
        font-size: 108px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #3292FF;
        margin-right: 12px;
      }
      .unit{
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        color: #3292FF;
        

        &::after{
          content: attr(data-unit);
          display: inline-block;
          font-size: 42px;
          vertical-align: text-top;
          transform: translateY(-13px);
        }
      }
    }
    .des{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      text-align: center;
    }
  }


  .cube-3{
    top: -170px;
    right: -240px;
    transform: scale(0.6) rotate(-30deg);
    position: absolute;
    width: 500px;
    height: 500px;
  }
  
}

.index-pattern-pc{
  // padding-bottom: 80px;
  .content{
    width: 1200px;
  }

  .info-content{
    width: 100%;
    padding-bottom: 80px;
    .spaceBetweenX;
    
    .block-content{
      width: 322px;
      height: 538px;
      border-radius: 20px;
      border: 1px solid #E1E1E1;
      position: relative;
      transition: all .5s;
      cursor: pointer;
      background-color: #fff;


      &.hover{
        width: 508px;
        box-shadow: 0px 10px 60px 0px rgba(239,244,250,1);
        
        .title{
          background: #3292FF;
          border-radius: 20px 20px 0px 0px;
          color: #fff;
          &::after{
            display: none;
          }

          .num{
            display: block;
            font-size: 30px;
          }
        }

        .bottom{
          .des{
            display: block;

            &.noWrap{
              .textOverflow;
            }
          }
        }

        .bg-icon{
          display: none;
        }
      }
    }

    .bg-icon{
      width: 190px;
      height: 160px;
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .title{
      font-size: 24px;
      color: #222222;
      .spaceBetweenX;
      padding: 45px 33px 38px 40px;
      position: relative;

      .num{
        display: none;
      }

      &::after{
        content: "";
        width: 20px;
        height: 2px;
        background: #222222;
        position: absolute;
        bottom: 0;
        left: 38px;
      }
    }

    .bottom{
      padding: 40px;

      .title-content{
        display: flex;
        font-size: 20px;
        padding-bottom: 12px;
        

        .stitle{
          .textOverflow;
        }
        
        img{
          width: 28px;
          height: 28px;
          margin-right: 6px;
        } 
      }

      .des{
        font-size: 18px;
        color: #666666;
        line-height: 32px;
        padding-bottom: 24px;
        display: none;
      }
    }
  }

  .cube-4{
    position: absolute;
    width: 1000px;
    height: 1000px;
    top: -290px;
    left: -560px;
    transform: scale(0.6) rotate(-30deg);
  }
  
}

.index-join-pc{
  padding-bottom: 80px;

  .lineCube2{
    width: 358px;
    height: 358px;
    border-radius: 25px;
    border: 1px solid #3292ff;
    position: absolute;
    bottom: 90px;
    right: -340px;
    transform: translate(-50%,60%) rotate(-45deg);
  }

  .lineCube3{
    width: 327px;
    height: 327px;
    border-radius: 25px;
    border: 1px solid #3292ff;
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translate(-50%,60%) rotate(-45deg);
  }

  .content{
    position: relative;
    width: 1200px;
  }

  .join-btn{
    width: 290px;
    height: 54px;
    background: #3292FF;
    border-radius: 12px;
    margin: 0 auto;
    .allCenter;
    font-size: 17px;
    color: #fff;
    cursor: pointer;

    &:hover{
      background-color: #2B80DF;
    }
  }


  .littleCube{
    position: absolute;
    z-index: -1;
  }

  .littleCube1,
  .littleCube2,
  .littleCube3{
    transform: translate(-120%, 120%) rotate(35deg);
  }
  .littleCube4,
  .littleCube5{
    transform: translate(120%, 120%) rotate(35deg);
  }

  .littleCube1{
    width: 32px;
    height: 32px;
    background: #3292ff;
    border-radius: 3px;
    top: 0;
    left: 2%;
    }

  .littleCube2{
    width: 28px;
    height: 28px;
    background: rgba(50,146,255,.1);
    border-radius: 3px;
    top: 71%;
    left: 15%;
  }

  .littleCube3{
    width: 28px;
    height: 28px;
    background: #fff;
    border-radius: 3px;
    border: 1px solid #3292ff;
    top: -37%;
    left: 20%;
  }

  .littleCube4{
    width: 28px;
    height: 28px;
    background: #3292ff;
    border-radius: 3px;
    top: -80%;
    right: 20%;
  }

  .littleCube5{
    width: 30px;
    height: 30px;
    background: rgba(50,146,255,.1);
    border-radius: 3px;
    top: 52%;
    right: 13%;
  }

  .littleCube6{
    width: 64px;
    height: 64px;
    top: -70%;
    right: -3%;
    background-image: url(//img.ibestfanli.com/xmilesWebsite2/littleCube6.png);
    background-size: 100% 100%;
    transform: translate(50%, 50%);
  }
}



@media screen and (min-width: 1200px) and (max-width: 1650px) {
  .index-top{
    .swiper-button-prev,
    .swiper-button-next{
      &.swiper-button-prev{
        left: 40px !important;
      }
      &.swiper-button-next{
        right: 40px !important;
      }
    }
  }
}

// 大屏ipad 1024 （基准1000）
@media screen and (min-width: 900px) and (max-width: 1200px) {
  .safeArea{
    width: 844px;
  }
  .content{
    .safeArea !important;
    padding-top: 60px;
    margin: 0 auto;
  }

  .small{
    display: block !important;
  }
  .big{
    display: none;
  }
  
  h1{
    // font-size: 35px;;
  }
  h2{
    // font-size: 35px !important;
    // padding-top: 78px;
  }
  h3{
    // font-size: 18px;
    padding-top: 12px !important;
  }

  .index-top{
    height: 654px;
    background-position: 30% center;

    .top-content{
      .info-content {
        background-position: 30% center !important;
      }
    }
  }

  .index-values-pc{
    .content{
      &::after{
        width: 140px;
        height: 140px;
        left: -140px;
        bottom: -70px;
      }
    }
    h2,
    h3{
      width: 842px;
    }

    .swiper-container{
      width: 469px;
      height: 469px;
    }

    .text-content{
      left: 469+63px;
      // top: 45+15px;

      .info{
        width: 250px;
      }
    }

    .values-swiper-scrollbar-content{
      // top: 120px;
      right: 0;
    }
  }

  .index-extenet-pc{
    .content{
      padding-top: 27px;
      height: 193px;
      padding-top: 29px;
    }
    .text-content{
      .num-content{
        .num{
          font-size: 86px;
        }
      }
    }
  }
  
  .index-pattern-pc{
    padding-bottom: 78px;
    .swiper-container{
      width: 100%;
      min-height: 404px;
      // overflow: inherit;
    }

    .swiper-slide{
      display: flex;
      justify-content: center;
    }

    .block-content{
      width: 242px;
      height: 314px;
      border-radius: 20px;
      border: 1px solid #E1E1E1;
      position: relative;
      background-color: #fff;
      margin-top: 40px;
      // transition: all 0.75s;

      .title{
        font-size: 18px;
        color: #222222;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 34px 25px 30px 30px;
        position: relative;

        &::after{
          content: "";
          width: 15px;
          height: 2px;
          background: #222222;
          position: absolute;
          bottom: 0;
        }

        .num{
          display: none;
        }
      }

      .bottom{
        padding: 40px;

        .title-content{
          display: flex;
          font-size: 15px;
          padding-bottom: 12px;

          img{
            width: 20px;
            height: 20px;
            margin-right: 5px;
          }
        }
        .des{
          display: none;
          max-height: 48px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
          padding-bottom: 18px;
          overflow: hidden;
        }
      }
    }

    .swiper-slide-active{
      box-shadow: 0px 7px 45px 0px rgba(239,244,250,1);
      .block-content{
        width: 100%;
        // height: 100%;
        height: 444px;
        overflow: hidden;
        margin-top: 0;

        .title{
          background: #3292FF;
          border-radius: 20px 20px 0px 0px;
          color: #fff;

          &::after{
            display: none;
          }
        }

        .num{
          display: block;
          font-size: 23px;
        }
        
        .des{
          display: block;
        }
      }
    }

    .pattern-swiper-scrollbar{
      // width: 135px;
      // height: 3px;
      width: 176px;
      height: 4px;
      background: #BBBBBB;
      border-radius: 2px;
      margin: 45px auto 0;
    }
  }

  .index-join-pc{
    .littleCube1{
      top: 59%;
      left: 2%;
    }
    .littleCube2{
      top: 91%;
      left: 14%;
    }
    .littleCube3{
      top: -39%;
      left: 17%;
    }
    .littleCube4{
      top: -39%;
      right: 16%;
    }
    .littleCube5{
      top: 81%;
      right: 6%;
    }
    .littleCube6{
      top: -20%;
      right: -2%;
    }
  }

}


// 小屏ipad 768 （基准768）
@media screen and /* (min-width: 768px) */ (min-width: 700px) and (max-width: 900px) {
  .safeArea{
    width: 648px;
  }
  .content{
    .safeArea !important;
    padding-top: 45px;
    margin: 0 auto;
  }

  .small{
    display: block !important;
  }
  .big{
    display: none;
  }

  h1{
    font-size: 27px !important;
  }
  h2{
    font-size: 27px !important;
    padding-top: 60px;
  }
  h3{
    padding-top: 9px;
  }


  .index-top{
    height: 503px;
    // .imgInfoP(100%, 503px, "index/top/img_banner_ipad.jpg");

    .top-swiper-scrollbar-content{
      bottom: 30px;
    }
  }


  .index-values-pc {
    // background-color: #efefef;
    padding-bottom: 45px;
    h2,
    h3{
      .safeArea;
      text-align: left;
    }
    h3{
      font-size: 27px;
      font-size: 14px;
    }

    .swiper-container{
      width: 360px;
      height: 360px;
    }

    .text-content{
      &::after{
        width: 107px;
        height: 107px;
        // transform: scale(.74);
        left: -120px;
        bottom: -70px;
        opacity: .5;
      }
      
      left: 360+48px;
      top: 14%;
      .title{
        padding-top: 15px;
        font-size: 21px;
      }
      .info{
        width: 218px;
        padding-top: 12px;
        font-size: 14px;
        line-height: 24px;
        height: 72px;

      }
    }

    .values-swiper-scrollbar-content{
      right: 0;
      width: 3px;
      height: 210px;
      top: 26.5%;
    }
  }

  .index-extenet-pc{
    padding-bottom: 45px;
    // background-color: #efefef;
    .point-ani-content{
      z-index: 1;
    }
    .content{
      padding-top: 45px;
      padding-bottom: 46px;
      height: 148px;
    }
    .text-content{
      position: relative;
      z-index: 2;
      width: 626px;

      .num-content{
        .num{
          font-size: 66px;
        }
        .unit{
          font-size: 21px;

          &::after{
            font-size: 32px;
            transform: translateY(-10px);
          }
        }
      }
      .des{
        font-size: 18px;
      }

    }
  }

  .index-pattern-pc{
    .content{
      width: 770px;
      padding-bottom: 60px;
    }

    .swiper-container{
      width: 100%;
      min-height: 404px;
      // overflow: inherit;
    }

    .swiper-slide{
      display: flex;
      justify-content: center;
    }

    .block-content{
      width: 242px;
      height: 314px;
      border-radius: 20px;
      border: 1px solid #E1E1E1;
      position: relative;
      background-color: #fff;
      margin-top: 40px;
      // transition: all 0.75s;

      .title{
        font-size: 18px;
        color: #222222;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 34px 25px 30px 30px;
        position: relative;

        &::after{
          content: "";
          width: 15px;
          height: 2px;
          background: #222222;
          position: absolute;
          bottom: 0;
        }

        .num{
          display: none;
        }
      }

      .bottom{
        padding: 40px;

        .title-content{
          display: flex;
          font-size: 15px;
          padding-bottom: 12px;

          img{
            width: 20px;
            height: 20px;
            margin-right: 5px;
          }
        }
        .des{
          display: none;
          max-height: 48px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
          padding-bottom: 18px;
          overflow: hidden;
        }
      }
    }

    .swiper-slide-active{
      box-shadow: 0px 7px 45px 0px rgba(239,244,250,1);
      .block-content{
        width: 100%;
        // height: 100%;
        height: 444px;
        overflow: hidden;
        margin-top: 0;

        .title{
          background: #3292FF;
          border-radius: 20px 20px 0px 0px;
          color: #fff;

          &::after{
            display: none;
          }
        }

        .num{
          display: block;
          font-size: 23px;
        }
        
        .des{
          display: block;
        }
      }
    }

    .pattern-swiper-scrollbar{
      width: 135px;
      height: 3px;
      background: #BBBBBB;
      border-radius: 2px;
      margin: 45px auto 0;
    }
  }

  .index-join-pc{
    padding-bottom: 60px;
    .content{

      .join-btn{
        width: 218px;
        height: 41px;
      }
    }

    .littleCube1{
      top: 59%;
      left: 2%;
    }
    .littleCube2{
      top: 91%;
      left: 14%;
    }
    .littleCube3{
      top: -39%;
      left: 17%;
    }
    .littleCube4{
      top: -39%;
      right: 16%;
    }
    .littleCube5{
      top: 81%;
      right: 6%;
    }
    .littleCube6{
      top: -20%;
      right: -10%;
    }


  }
}
</style>

<style lang="less">
.indexPc{
  .top-swiper-scrollbar-content{
    position: absolute;
    bottom: 42px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 88;

    .swiper-pagination-bullet{
      width: 16px;
      height: 4px;
      background: #FFFFFF;
      opacity: .4;
      border-radius: 3px;
      margin-left: 5px;

      &.swiper-pagination-bullet-active{
        opacity: 1;
      }
    }
  }
  .values-swiper-scrollbar-content{
    .swiper-pagination-bullet{
      width: 100%;
      height: 20%;
      border-radius: 0;
      display: block;
      
      &.swiper-pagination-bullet-active{
        background-color: #222222;
      }
    }
  }
}
</style>